import React from 'react';
import {
  Content,
  Form,
  Title,
  Description,
  StrongPassword,
  ButtonContent,
  FormCenter,
} from './styles';
import validateStrongPassword from '../../../utils/validateStrongPassword';
import MetaTitle from '../../MetaTitle';
import Input from '../Input';
import { VisibilityOutlined, VisibilityOffOutlined } from '@mui/icons-material';
import { Button, FormController } from '../../../assets/global/globalStyles';
import { resetPassword, userLogout } from '../../../store/user';
import { passwordForm } from '../../../utils/formVerifications';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function FormChangePassword() {
  const [visibility, setVisibility] = React.useState(true);
  const navigate = useNavigate();
  const [strong, setStrong] = React.useState(0);
  const formRef = React.useRef(null);
  const dispatch = useDispatch();  
  const {email} = useSelector(state => state.user.data)

  const handleSubmit = async (data) => {
    formRef.current.setErrors({});
    const { payload, error } = await passwordForm(data);
    if (payload) {
      await dispatch(resetPassword({email: email, newPassword: payload.newPassword, oldPassword: payload.oldPassword}));
      navigate(-1);
    }
    if (error) return formRef.current.setErrors(error);
  };

  const onChangePassword = ({ target: { value } }) => {
    setStrong(validateStrongPassword(value));
  };

  const showStrength = () => {
    if (strong < 30) return 'Fraca';
    if (strong >= 30 && strong < 50) return 'Média';
    if (strong >= 50 && strong < 70) return 'Forte';
    if (strong >= 70 && strong < 100) return 'Excelente';
  };

  const toggleVisibility = () => {
    setVisibility(!visibility);
  };

  const visibilityPassword = () =>
    visibility ? (
      <VisibilityOffOutlined
        style={{ color: 'var(--color)', width: '25px', height: '25px' }}
        onClick={toggleVisibility}
      />
    ) : (
      <VisibilityOutlined
        style={{ color: 'var(--color)', width: '25px', height: '25px' }}
        onClick={toggleVisibility}
      />
    );

  return (
    <FormCenter>
      <Form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
        <MetaTitle title="Redefinir senha" />
        <Title>Redefinir senha</Title>
        <Content>
          <FormController>
            <Input
              type={visibility ? 'password' : 'text'}
              label="Senha atual"
              name="oldPassword"
              autoFocus
            >
              {visibilityPassword()}
            </Input>
          </FormController>
          <FormController>
            <Input
              type={visibility ? 'password' : 'text'}
              label="Altere sua senha"
              onChange={onChangePassword}
              name="newPassword"
            >
              {visibilityPassword()}
            </Input>
          </FormController>
          <StrongPassword strength={strong}>{showStrength()}</StrongPassword>
          <FormController>
            <Input
              type={visibility ? 'password' : 'text'}
              label="Confirme sua senha"
              name="passwordConfirmed"
            >
              {visibilityPassword()}
            </Input>
          </FormController>
          <Description>
            Deve ter pelo menos 8 caracteres (letras, números e caracteres
            especiais)
          </Description>
          <ButtonContent>
            <Button
              typeName="success"
              disabled={strong < 50}
              title={'Deverá conter uma senha de nível forte!'}
            >
              Salvar senha
            </Button>
            <Button
              typeName="danger"
              onClick={() => {
                dispatch(userLogout());
              }}
            >
              Voltar
            </Button>
          </ButtonContent>
        </Content>
      </Form>
    </FormCenter>
  );
}
